import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

type Command = {
  groupId: string;
  quoteId: string;
};

async function deleteQuote(command: Command) {
  const { error } = await apiClient.from('quotes').delete().eq('id', command.quoteId);

  if (error) {
    throw error;
  }
}

export function useDeleteQuote() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: deleteQuote,
    onSuccess: (_data, command) => {
      queryClient.invalidateQueries({ queryKey: keys.groupQuotes(command.groupId) });
      queryClient.invalidateQueries({ queryKey: keys.groupsList(currentSpace!.id) });
      enqueueSnackbar('Devis supprimé.', 'success');
    },
  });
}
